export const getProgress = (state) => state.courseImport.progress;
export const getCurrentStage = (state) => state.courseImport.currentStage;
export const getImportTriggered = (state) => state.courseImport.importTriggered;
export const getFileName = (state) => state.courseImport.fileName;
export const getError = (state) => state.courseImport.error;
export const getLoadingStatus = (state) => state.courseImport.loadingStatus;
export const getSavingStatus = (state) => state.courseImport.savingStatus;
export const getSuccessDate = (state) => state.courseImport.successDate;
